import { defaultHttpClient } from '../../httpClient';
import type { BeautyRecommendedOptionResponse } from './types';

/**
 * - 뷰티 추천 옵션 조회 API
 * - GET /api/v2/goods/{sno}/beauty-recommended-option/
 */
export const getBeautyRecommendedOption = (goodsSno: number) => {
  return defaultHttpClient
    .request<BeautyRecommendedOptionResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/beauty-recommended-option/`,
    })
    .then(result => result.data);
};
